export enum ROLES {
  Administrator = 'CCenter.Administrator',
  ScaniaIT = 'CCenter.IT',
  InspectorSLA = 'CCenter.Inspector.User.SLA',
  SecuritySLA = 'CCenter.Security.SLA',
  SecurityLCB = 'CCenter.Security.LCB',
  GeneralUserSLA = 'CCenter.General.User.SLA',
  GeneralUserLCB = 'CCenter.General.User.LCB',
}
